import styles from './Title.module.scss';
import cn from 'classnames';

export default function Title({
  text,
  size = 'medium',
  level = 2,
  className
}: {
  text: string;
  size?: 'small' | 'medium' | 'large';
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
}) {
  const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;

  return (
    <div className={cn(styles.root, className)}>
      <HeadingTag
        style={{
          fontSize:
            size === 'small' ? '16px' : size === 'medium' ? '24px' : '30px'
        }}
      >
        {text}
      </HeadingTag>
    </div>
  );
}
